<template>
    <div>
        <modal
            class="new-modal-small"
            :name="modal_name"
            transition="nice-modal-fade"
            :delay="100"
            height="auto"
            :min-height="200"
            :min-width="400"
            :pivot-y="0.5"
            :adaptive="true"
            :scrollable="true"
        >
            <div class="v-modal-content d-flex flex-column justify-content-center align-items-center text-center" style="background-color: #fff !important; height: 22em !important;">
                <img src="/static/images/parrot.svg" style="height: 10rem !important" />
                <div class="mt-5" style="font-size: 16px">
                    <div class="fw-600 mb-4" style="font-size: 20px; color: #0475f3">Success</div>
                    {{ name }} removed Successfully
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
export default {
    props: ["modal_name","name"],
}
</script>